// extracted by mini-css-extract-plugin
export default {"title":"about-us_title__PNQKR","description":"about-us_description__cUfKV"};